import Row from '@app/components/layout/Row'
import { Title } from '@app/components/core/typography/Title'
import { Text } from '@app/components/core/typography/Text'
import { TextLink } from '@app/components/core/link/TextLink'
import Column from '@app/components/layout/Column'
import { faArrowRight } from '@fortawesome/pro-regular-svg-icons'
import useMediaQuery from '@app/util/useMediaQuery'
import { Style } from 'inlines'

export type SectionHeaderProps = {
  title: string
  subtitle?: string
  seeMore?: string
  toRoute?: string
  style?: Style
}

export const SectionHeader = ({
  title,
  subtitle,
  seeMore,
  toRoute,
  style,
}: SectionHeaderProps) => {
  const isMobile = useMediaQuery()
  return (
    <Row
      style={{
        justifyContent: 'space-between',
        alignItems: 'flex-start',
        ...style,
      }}
    >
      <Column
        alignItems="stretch"
        style={{
          flex: isMobile ? '1' : '0 1 50%',
        }}
      >
        <Title.H4 style={{ marginBottom: subtitle ? '0.5rem' : '1rem' }}>
          {title}
        </Title.H4>
        {subtitle && <Text.Medium>{subtitle}</Text.Medium>}
      </Column>
      {seeMore && (
        <Column
          alignItems="flex-end"
          style={{
            justifyContent: 'flex-end',
            flex: '0 0 auto',
            minWidth: 'fit-content',
          }}
        >
          <TextLink icon={faArrowRight} to={toRoute || '#'}>
            {seeMore}
          </TextLink>
        </Column>
      )}
    </Row>
  )
}
